import star1 from "./static/icon/star1.svg";
import lightStar1 from "./static/light-icon/star1.svg";
import star2 from "./static/icon/star2.svg";
import lightStar2 from "./static/light-icon/star2.svg";
import star3 from "./static/icon/star3.svg";
import lightStar3 from "./static/light-icon/star3.svg";

export const TASK_TYPE = {
	LANGUAGE_SAFETY: {
		code: "language-safety",
		title: "Language Safety",
		cnTitle: "Language Safety",
		subtitle: "Ensuring Safe and Respectful Communication",
		type: "0",
		icon: star1,
		lightIcon: lightStar1,
	},

	QUERY_DATA: {
		code: "data-gpt",
		title: "Query Data",
		cnTitle: "查询数据",
		cnTitle1: "金融知识类客服机器人",
		type: "1",
		subtitle: "Empowering Data Retrieval with Precision",
		cnsubtitle: "精准赋能数据检索",
		icon: star2,
		lightIcon: lightStar2,
	},
	CHECK_LABEL: {
		code: "data-gpt",
		title: "Check Label",
		cnTitle: "Check Label",
		type: "2",
		subtitle: "Verifying Labels for Better Data Integrity",
		icon: star3,
		lightIcon: lightStar3,
	},
	LOW_QUALITY_DETECTION: {
		code: "low-quality-detection",
		title: "Low Quality Detection",
		cnTitle: "Low Quality Detection",
		subtitle: "Low Quality Detection",
		type: "3",
		icon: star1,
		lightIcon: lightStar1,
	},
};

export interface TaskType {
	code: string;
	title: string;
	type?: string;
	subtitle?: string;
}

export const NODATATEXT =
	"We only answer data-related questions, please restate your purpose.";

export const WARMUPTEXT = "Please tell";

export const US_TEXT = {
	NEWCHAT: "New Chat",
	RECENT: "Recent",
	SOMEDATA: "Here are some data :",
	QUERYDATA: "Query Data",
	INPUTPLACEHOLDER: "Enter your message here",
	WANTMOREDATA: "Want more data? ",
};

export const CN_TEXT = {
	NEWCHAT: "新建对话",
	RECENT: "最近对话",
	SOMEDATA: "以下是一些数据 : ",
	QUERYDATA: "查询数据",
	INPUTPLACEHOLDER: "发送消息",
	WANTMOREDATA: "需要更多数据？",
};


export const appId = "wx364517dcab5ed436";
